import React from 'react';
import { connect } from 'react-redux';
import { addCart as addToCart } from 'shared/components/cart/actions';
import { LightBackground } from 'scy/Background';
import { Body, SecondaryBody } from 'scy/text';
import { sansSerifBlack } from 'scy/text/styles.mod.scss';
import { LoadingButton, SecondaryButton } from 'scy/buttons';
import styles from './styles.mod.scss';
import margin from 'scy/margin.mod.scss';

class GiftBag extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  addToCart() {
    this.setState({ loading: true });
    return this.props.addToCart(this.props.giftBag).finally(() => {
      this.setState({ loading: false });
    });
  }

  render() {
    const { giftBag } = this.props;

    if (!giftBag.price) return null;

    return (
      <LightBackground tag="section" className={styles.giftBagSection}>
        <img className={styles.giftBagImage} src={giftBag.image} />
        <div className={`${margin.right_xs} ${margin.bottom_xs}`}>
          <Body className={sansSerifBlack}>{giftBag.title}</Body>
          <Body>
            {giftBag.subtitle} | {giftBag.volume} | ${giftBag.priceDisplay}{' '}
          </Body>
          <SecondaryBody marginClass={`${margin.top_0} ${margin.bottom_xs}`}>
            {giftBag.description}
          </SecondaryBody>
          <LoadingButton
            Button={SecondaryButton}
            onClick={() => this.addToCart()}
            disabled={this.state.loading}
            loading={this.state.loading}
          >
            Add to Cart
          </LoadingButton>
        </div>
      </LightBackground>
    );
  }
}

const ConnectedGiftBag = connect(
  state => ({
    giftBag: state.checkout.giftBag,
    lat: state.address.lat,
    lng: state.address.lng,
    address: state.address
  }),
  {
    addToCart
  }
)(GiftBag);

export default ConnectedGiftBag;
